module.exports = __webpack_public_path__ + "img/insta.bb26ee15.png";